module.exports = __webpack_public_path__ + "img/bg1.989d15ea.jpg";